<div class="sidebar-header-wrapper">
  <span data-sidebar-action="done" data-tooltip="Back to menu" data-tooltip-position="bottom-right" class="edit-component-actions component-back-arrow">
    {{{ icon 'arrow-left' }}}
  </span>
  <h2>
    {{ name }}
  </h2>
  
  <div role="tablist" class="tab-selectors tab-selectors tab-selectors--secondary edit-form-nav"><span role="tab" class="tab-selector tab-selector--first" tabindex="0"><label for="tab_component-content"><input class="tab-selector-radio" type="radio" checked="checked" title="Content" name="tab_group_17672" value="tab_component-content" data-behaviour="tabstate" aria-controls="tab_component-content_content" id="tab_component-content" /><span class="tab-label"><div class="tab-text">Content</div></span></label></span><span role="tab" class="tab-selector" tabindex="0"><label for="tab_component-config"><input class="tab-selector-radio" type="radio" title="Configuration" name="tab_group_17672" value="tab_component-config" data-behaviour="tabstate" aria-controls="tab_component-config_content" id="tab_component-config" /><span class="tab-label"><div class="tab-text">Configuration</div></span></label></span><span role="tab" class="tab-selector" tabindex="0"><label for="tab_component-appearance"><input class="tab-selector-radio" type="radio" title="Style" name="tab_group_17672" value="tab_component-appearance" data-behaviour="tabstate" aria-controls="tab_component-appearance_content" id="tab_component-appearance" /><span class="tab-label"><div class="tab-text">Style</div></span></label></span><span role="tab" class="tab-selector tab-selector--last" tabindex="0"><label for="tab_component-behavior"><input class="tab-selector-radio" type="radio" title="Behavior" name="tab_group_17672" value="tab_component-behavior" data-behaviour="tabstate" aria-controls="tab_component-behavior_content" id="tab_component-behavior" /><span class="tab-label"><div class="tab-text">Behavior</div></span></label></span></div>
</div>
<div class="settings-content-container {{#inherited}}inherited-component{{else}}unique-component{{/inherited}}">
  <div class="tab-content-container"><div class="tab-content" role="tabpanel" id="tab_component-content_content"><div class="loaded-tools loaded-tools-wrapper">
  <p class="components-coaching">
    {{{ icon 'category' }}}
    <span class="text">
      {{#inherited}}
        <strong class="title component-variant" data-help="components">Inherited Component</strong>
      {{else}}
        <strong class="title component-variant" data-help="components">Unique Component</strong>
      {{/inherited}}
      {{#hasInheritors}}
      <a class="subtitle inheritor-count">Inherited by {{inheritorCount}} pages</a>
      {{/hasInheritors}}
    </span>
  </p>
</div>
</div><div class="tab-content" role="tabpanel" id="tab_component-config_content" style="display: none;"><div class="loaded-config loaded-tools-wrapper"></div>
</div><div class="tab-content" role="tabpanel" id="tab_component-appearance_content" style="display: none;"><div class="loaded-appearance loaded-tools-wrapper"></div>
</div><div class="tab-content" role="tabpanel" id="tab_component-behavior_content" style="display: none;"><div class="loaded-behavior loaded-tools-wrapper"></div>
</div></div>

  <div class="info-and-actions {{#inherited}}inherited{{else}}unique{{/inherited}}" data-behaviour="close-on-clickout">
    <a href="#" class="info-header" data-behaviour="toggleable" data-target="#info-and-actions-content">
      <span class="icon-wrapper"><svg class="icon icon-chevron-up  toggle-info-and-actions"><use xlink:href="/assets/admin/svg_icon_sprite-ed97dbd7.svg#icon-chevron-up" class="icon__use icon__use--default"></use></svg></span>
      <span>Info & Actions</span>
      {{{ icon 'info-filled' }}}
    </a>

    <div id="info-and-actions-content">
      <div class="info-content">
        <dt>Type:</dt><dd>{{ name }}</dd>
        <dt>Created:</dt><dd>{{ audit.created_at }}</dd>
        <dt>Modified:</dt><dd>{{ audit.updated_at }}</dd>
        {{#inherited}}
        <dt>Inherited From:</dt><dd><a href="{{inheritedFromURL}}" target="_blank">{{ replaces }}</a></dd>
        {{/inherited}}

        {{#hasInheritors}}
        <dt class="component-inheritors-title">Inherited By:</dt>
        <dd class="component-inheritors-data">
          <ul>
          {{#each inheritors }}
            <li><a href="{{this.url}}" title="{{this.inheritance_message}}">{{this.name}}</a></li>
          {{/each }}
          </ul>
        </dd>
        {{/hasInheritors}}

        {{#each images }}
          {{#if this.file_name}}
            <hr>
            <span class="image-details">Image Details for {{ this.file_name }}</span>
            <dt>Dimensions:</dt><dd>{{ this.width }} × {{ this.height }}</dd>
            <dt>File Size:</dt><dd>{{ this.file_size }}</dd>
          {{/if}}
        {{/each }}
      </div>

      <div class="action-content {{#inherited}}inherited-component{{/inherited}}">
        {{#if inherited}}
        <a class="component-action-button delete-component" href="javascript:void(0)"><span class="icon-wrapper"><svg class="icon icon-hide "><use xlink:href="/assets/admin/svg_icon_sprite-ed97dbd7.svg#icon-hide" class="icon__use icon__use--default"></use></svg></span>Hide This Component</a>
        {{else}}
        <a class="component-action-button convert-component" href="javascript:void(0)"><span class="icon-wrapper"><svg class="icon icon-duplicate "><use xlink:href="/assets/admin/svg_icon_sprite-ed97dbd7.svg#icon-duplicate" class="icon__use icon__use--default"></use></svg></span>Convert to Shared Component</a>
        <a class="component-action-button delete-component" href="javascript:void(0)"><span class="icon-wrapper"><svg class="icon icon-trash "><use xlink:href="/assets/admin/svg_icon_sprite-ed97dbd7.svg#icon-trash" class="icon__use icon__use--default"></use></svg></span>Delete This Component</a>
        {{/if}}
      </div>
    </div>
  </div>
</div>
